import moment from 'moment';
import { getUser } from '@/plugins/auth';
import { formatPerson } from '@/utils/person';
import { isArray } from 'lodash';

export default {
	setPersons(state, value) {
		if (isArray(value)) {
			state.persons = formatPerson(value);
		} else {
			state.persons = [
				...state.persons.filter(element => element._id !== value._id),
				formatPerson([value])[0],
			];
		}
	},
	setNewPersons(state, value) {
		const newPersons = value.map(person => formatPerson([person.person])[0]);
		state.persons = [...state.persons, ...newPersons];
	},
	setPerson(state, value) {
		if (value) state.person = formatPerson([value])[0];
		else state.person = null;
	},
	setPersonsByUser(state, value) {
		state.personsByUser = formatPerson(value);
	},
	setMessage(state, value) {
		state.message = value;
		setTimeout(() => {
			state.message = '';
		}, 300);
	},
	setLoading(state, value) {
		state.loading = value;
	},
	setNotified(state, conversation) {
		const userId = getUser()._id;
		const conversations = conversation.filter(item => !item.read && item.senderId !== userId);
		state.notified = conversations.length;
	},
	setDocumentBadge(state) {
		const itsDue = state.person.documents.some(
			doc => doc && moment(doc.date).isBefore(moment().format())
		);
		const pending = state.person.typeDocument.some(
			(doc, i) => doc && !state.person.documents[i]
		);
		state.documentBadge = itsDue || pending;
	},
};
